import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import CustomSelect from "../../../../helpers/ui/CustomSelect"
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import DatePicker from '../../../../helpers/ui/DatePicker'
import CreateBloc from './Blocs/CreateBloc'
import moment from 'moment'

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionTypes : [
                { label: "Seluruh Pegawai Tanpa Terkecuali", value: 1 },
                { label: "Seluruh Pegawai Dengan Pengecualian", value: 2 },
                { label: "Seluruh Pegawai Yang Melakukan Finger / Mobile", value: 3 }
            ],
            employeeOptions: [],
            selectedEmployee: null,
            selectedType: null,
            isLoadingOptEmployee: true,
            listExclude: []
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data['employee_nip'] +' - '+ data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    addList = () => {
        let emp = this.state.selectedEmployee;
        let obj = {
            uuid: emp.employee_uuid,
            nip: emp.employee_nip,
            nama: emp.employee_full_name
        }
        let temp = this.state.listExclude.filter((val) => val.nip!=emp.employee_nip)
        temp.push(obj);
        this.setState({
            listExclude : temp
        })
    }

    deleteList = (data) => {
        this.setState({
            listExclude: [
                ...this.state.listExclude.filter((val) => val.nip!=data.nip)
            ]
        })
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              excludes : this.state.listExclude,
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            employeeOptions: this.reformatOptions(
                                response.result,
                                'employee_full_name',
                                'employee_uuid',
                            ),
                            isLoadingOptEmployee: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.fetchEmployee()
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.employeeChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Proses Pemutihan Absen</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_adjustment_type"
                                                className="col-md-3 col-form-label"
                                            >
                                            Metode <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name={`presensi_adjustment_type`}
                                                    errorMessage="Pilih Metode"
                                                    options={this.state.optionTypes} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Metode"
                                                    // isLoading={this.state.isLoadingOptEmployee}
                                                    onChange={
                                                        (v) => this.setState({
                                                            selectedType: v.value
                                                        })
                                                    }
                                                    // defaultValue={data.type}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_adjustment_start_date"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Awal <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <DatePicker 
                                                    name={`presensi_adjustment_start_date`}
                                                    isWeekday={true}
                                                    dateFormat="dd/MM/yyyy"
                                                    errorMessage="Masukan Tanggal Awal"
                                                    validate={{ required: { value: true } }}
                                                    maxDate={moment().format('YYYY-MM-DD')}
                                                /> 
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_adjustment_start_date"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Akhir <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <DatePicker 
                                                    name={`presensi_adjustment_end_date`}
                                                    isWeekday={true}
                                                    dateFormat="dd/MM/yyyy"
                                                    errorMessage="Masukan Tanggal Akhir"
                                                    validate={{ required: { value: true } }}
                                                    maxDate={moment().format('YYYY-MM-DD')}
                                                /> 
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_adjustment_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="presensi_adjustment_description"
                                                    placeholder="Keterangan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="presensi_adjustment_description"
                                                />
                                            </Col>
                                        </Row>

                                        {
                                            this.state.selectedType == 2 && 
                                            <>
                                                <hr />
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="presensi_exclude_absen_employee_uuid"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                    Pegawai <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="5">
                                                        <CustomSelect 
                                                            name={`presensi_exclude_absen_employee_uuid`}
                                                            errorMessage="Pilih Pegawai"
                                                            options={this.state.employeeOptions} 
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Pegawai"
                                                            isLoading={this.state.isLoadingOptEmployee}
                                                            onChange={
                                                                (v) => this.setState({
                                                                    selectedEmployee: v.model
                                                                })
                                                            }
                                                            // defaultValue={data.type}
                                                        />
                                                    </Col>
                                                    <Col md="2">
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                            color="success" 
                                                            type="button"
                                                            onClick={() => this.addList()}
                                                            disabled={this.state.selectedEmployee != null ? false : true}
                                                            ><i className="uil-plus-circle"></i>
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="no_sk"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                    NIP 
                                                    </label>
                                                    <Col md="3">
                                                        <AvField
                                                            placeholder=""
                                                            name="presensi_exclude_absen_employee_nip"
                                                            id="presensi_exclude_absen_employee_nip"
                                                            readonly="readonly"
                                                            type="text"
                                                            className="form-control"
                                                            value={this.state.selectedEmployee?.employee_nip}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="no_sk"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                    Nama 
                                                    </label>
                                                    <Col md="3">
                                                        <AvField
                                                            placeholder=""
                                                            name="presensi_exclude_absen_employee_nama"
                                                            id="presensi_exclude_absen_employee_nama"
                                                            readonly="readonly"
                                                            type="text"
                                                            className="form-control"
                                                            value={this.state.selectedEmployee?.employee_full_name}
                                                        />
                                                    </Col>
                                                </Row>

                                                <hr />

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="no_sk"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Daftar Pengecualian 
                                                    </label>
                                                    <Col md="8">
                                                        <Table className='table-striped'>
                                                            <thead>
                                                                <tr>
                                                                    <td>No</td>
                                                                    <td>NIP</td>
                                                                    <td>Nama</td>
                                                                    <td>Aksi</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                this.state.listExclude.length > 0 ? 

                                                                    this.state.listExclude.map((data, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <td>{index+=1}</td>
                                                                                <td>{data.nip}</td>
                                                                                <td>{data.nama}</td>
                                                                                <td>
                                                                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                        color="danger" 
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                            this.deleteList(data)
                                                                                        }}
                                                                                        ><i className="uil-trash-alt"></i>
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })

                                                                : 
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">Tidak Ada Data</td>
                                                                </tr>
                                                            }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            
                                            </>
                                        }

                                        {
                                            this.state.selectedType != 2 && 
                                            <label style={{ marginBottom: '100px' }}></label>
                                        }

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Proses Pemutihan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/pemutihan.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView